import { useNavigate } from 'react-router';

import { Box, Button, Typography } from '@mui/material';

/**
 * Pagina resposta ao codigo http 404. Quando a rota não leva a lugar nenhum.
 */
export function Page404() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100dvh',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3,
                backgroundColor: (theme) => theme.palette.grey[100],
            }}
        >
            <Typography variant="h1">404</Typography>

            <Typography variant="h4">Página não encontrada.</Typography>

            <Box
                sx={{
                    display: 'flex',
                    mt: 3,
                }}
            >
                <Button variant="contained" type="button" onClick={() => navigate('/')}>
                    Página Inicial
                </Button>

                <Button variant="contained" sx={{ ml: 3 }} type="button" onClick={() => navigate(-1)}>
                    Voltar
                </Button>
            </Box>
        </Box>
    );
}
